import React from 'react'
import CloudServicesHero from "./section/CloudServicesHero.js"
import Fullstackcloud from "./section/Fullstackcloud.js"
const CloudServices = () => {
  return (
    <>
    <CloudServicesHero/>
    <Fullstackcloud/>
    </>
  )
}

export default CloudServices